import { ProductFeatureAccountModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../../shared';
import { ProductFeatureAccountParticipation } from './product-feature-account-participation.entity';

export class ProductFeatureAccount extends DomainEntity<ProductFeatureAccountModelDto> {
    public createDefault(): this {
        throw new Error('Method not implemented.');
    }

    public get featureParticipations() {
        return (
            this.dto.featureParticipations?.map(
                dto => new ProductFeatureAccountParticipation(dto)
            ) ?? []
        );
    }

    public set featureParticipations(value: ProductFeatureAccountParticipation[]) {
        this.dto.featureParticipations = value.map(item => item.toDto());
    }

    public get featureName() {
        return this.dto.featureName;
    }
}
